export enum BankReceiptStatus {
 Available = 1,
 Claimed = 3,
 Rejected = 4,
 'Read Only' = 5
}
